module.exports = __webpack_public_path__ + "static/media/google.d55c9026.svg";